var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Toolbar", {
        ref: "toolbar",
        attrs: {
          editor: _vm.editor,
          defaultConfig: _vm.toolbarConfig,
          mode: _vm.mode,
        },
      }),
      _c("Editor", {
        ref: "editor",
        staticClass: "editor",
        style: {
          minHeight: "500px",
          overflowY: "auto",
          backgroundColor: "white",
          ..._vm.editorStyle,
        },
        attrs: {
          id: "editor",
          defaultConfig: _vm.editorConfig,
          mode: _vm.mode,
          readOnly: _vm.readOnly,
        },
        on: {
          onChange: _vm.onChange,
          onCreated: _vm.onCreated,
          customPaste: (editor, event) => this.pasteText(editor, event),
        },
        model: {
          value: _vm.html,
          callback: function ($$v) {
            _vm.html = $$v
          },
          expression: "html",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }